import { instantsInterceptor, } from '@/api/index';

function getTsg(form) {
    return instantsInterceptor.post('/service/tsg/list',form);
}

function tsgList(form) {
    return instantsInterceptor.post('/mgmt/tsg/list',form);
}

function getTsgForm(tsgId) {
    return instantsInterceptor.get('/mgmt/tsg/form?tsgId='+tsgId);
}

function tsgUpdate(form) {
    return instantsInterceptor.post('/mgmt/tsg/update',form);
}

function tsgDelete(form) {
    return instantsInterceptor.post('/mgmt/tsg/delete',form);
}

function tsgPdfDownload(uid) {
    return instantsInterceptor.get('/document/tsg/predown?uid=' + uid);
}

export { tsgList, getTsgForm, tsgUpdate, tsgDelete, getTsg, tsgPdfDownload};